import Table from './table';

const DatabaseTable = Table;

export default DatabaseTable;
